import { Component, Input } from '@angular/core'
import { EAHistoryData, GenerationData } from '../../metrics/ea-history-data'
import { Color, DataItem, LineChartModule, ScaleType, Series } from '@swimlane/ngx-charts'

@Component({
  selector: 'app-job-detail-convergence',
  templateUrl: './job-detail-convergence.component.html',
  styleUrls: ['./job-detail-convergence.component.scss'],
  imports: [LineChartModule],
})
export class JobDetailConvergenceComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  @Input()
  public xAxisLabel = 'Generation'
  @Input()
  public yAxisLabel = 'Objective Value'

  protected multi: Series[] = []

  protected legend = true
  protected xAxis = true
  protected yAxis = true
  protected showYAxisLabel = true
  protected showXAxisLabel = true
  protected timeline = true
  protected autoscale = true

  protected colorScheme: Color = {
    name: 'customScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#5AA454', '#E44D25', '#7aa3e5'],
  }

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set historyData(historyData: EAHistoryData) {
    const numOfObjectives = historyData.generations[0].objectives.length

    // *** Initialize arrays ***
    const dataPoints: DataItem[][] = []
    // Objectives + Fitness + Mean Fitness
    for (let i = 0; i < numOfObjectives + 2; i++) {
      dataPoints.push([])
    }

    // *** Gather data ***
    for (let iteration = 0; iteration < historyData.generations.length; iteration++) {
      const gd = historyData.generations[iteration]
      // Objectives
      for (let i = 0; i < gd.objectives.length; i++) {
        const objective = <DataItem>{ name: iteration.toString(), value: gd.objectives[i] }
        dataPoints[i].push(objective)
      }
      // Fitness
      const fitness = <DataItem>{ name: iteration.toString(), value: gd.fitness }
      dataPoints[numOfObjectives].push(fitness)
      const meanFitness = this.calculateMeanFitness(iteration, historyData, gd)
      dataPoints[numOfObjectives + 1].push(meanFitness)
    }

    // *** Transfer to model ***
    // Objectives: Transfer data
    for (let i = 0; i < numOfObjectives; i++) {
      this.multi.push(<Series>{ name: historyData.objectiveLabels[i], series: dataPoints[i] })
    }
    // Fitness: Transfer data
    this.multi.push(<Series>{ name: 'Fitness', series: dataPoints[numOfObjectives] })
    this.multi.push(<Series>{ name: 'Mean Fitness', series: dataPoints[numOfObjectives + 1] })
    // this.multi = this.multi.map(series => this.applyLogScale(series));
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private calculateMeanFitness(
    iteration: number,
    historyData: EAHistoryData,
    current: GenerationData
  ): DataItem {
    if (iteration >= 2 && this.isOutlier(current)) {
      const previousGeneration = historyData.generations[iteration - 1]
      const outlierReplacement =
        (previousGeneration.meanPopulationFitness +
          historyData.generations[iteration - 2].meanPopulationFitness) /
        2
      return <DataItem>{ name: iteration.toString(), value: outlierReplacement }
    } else {
      return <DataItem>{ name: iteration.toString(), value: current.meanPopulationFitness }
    }
  }

  private isOutlier(gd: GenerationData): boolean {
    return gd.meanPopulationFitness > 10 * gd.fitness
  }
}
